__turbopack_context__.v({
  "container": "ProductAllergyInformation-module-scss-module__lHuFNG__container",
  "heading": "ProductAllergyInformation-module-scss-module__lHuFNG__heading",
});
